module.exports = __webpack_public_path__ + "static/yarra_1_square-397695bf696d5d292d0805f36fc8578f.jpg";